module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"placeholder":"Suche","label":"Gemeinde"},"fr":{"placeholder":"Recherche","label":"Communauté"},"en":{"placeholder":"Search","label":"Municipality"}}')
  delete Component.options._Ctor
}
